import NewPaymentModal, {ADD_CREDIT} from "template/Modals/NewPayment";
import { alert } from 'util/alert';

// Open payment Modal
// NOTE: 'this' here is a TabComponent (eg. DefaultTab)
export default function payment({ trData: student }) {
  const {
    user,
    studentState,
  } = this.props;

  const { fetchStudent } = this.props.student;

  NewPaymentModal({ student, user_id: user.result.user_id, paymentType: ADD_CREDIT })
  .then(({ success })=>{
    if (success == true) {
      fetchStudent('After payment is successful', studentState);
    }
  }).catch((err)=>{
    console.error(err);
  });
}



// WEBPACK FOOTER //
// ./src/containers/pages/Student/payment.js